import initStore from '@/stores/init';
import { getQueryForm } from '@/utils/instantLoaded/toolsWithoutDeps';
import { consumptionDatasByCsFillToken } from '@/services/chat';

export const consumptionCSFillDatas = async () => {
  try {
    const { searchUrl = '' } = initStore;
    const csFillTokenParam = getQueryForm('csFillToken', searchUrl);
    if (!csFillTokenParam) {
      return {};
    }
    const datas = await consumptionDatasByCsFillToken({ cs_fill_token: csFillTokenParam });
    // @ts-ignore
    const { payload } = datas || {};
    return typeof payload === 'string' ? JSON.parse(payload) : payload;
  } catch (error) {
    return {};
  }
};
